import { createBrowserRouter, RouteObject } from "react-router-dom";
import { HOME, PRIVACY_POLICY } from "./configs/path";
import Home from "./pages/home";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";

const routes: RouteObject[] = [
  {
    path: HOME,
    element: <Home />,
  },
  {
    path: PRIVACY_POLICY,
    element: <PrivacyPolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

const router = createBrowserRouter(routes);

export default router;
